import { Component, OnInit } from '@angular/core';
import { AmaService } from '../ama.service';
import { Router } from '@angular/router';
import { DialogServiceService } from '../dialog-service.service';
import { NotifierService } from 'angular-notifier';

interface ListElement {
  question: string;
  submissionDate: string;
  status: string;
}

@Component({
  selector: "app-ask-list",
  templateUrl: "./ask-list.component.html",
  styleUrls: ["./ask-list.component.css"],
})
export class AskListComponent implements OnInit {
  
  constructor(public amaService: AmaService,private notifier:NotifierService, private router: Router, private Dialog: DialogServiceService) { }
  displayedColumns :string[]  = ['serialNo','question','submissionDate','status','details','report'];
  dataSource  =  this.amaService.userAskedQuestions['data'];


  ngOnInit() {
    this.amaService.fetchUserAskedQuestion();
    this.amaService.fetchSampleData();
    //console.log(this.dataSource,'Hii How Are You');
    // console.log("amaService.filterData::", this.amaService.filterData)
  }
  btnDisable() {
  console.log("btnDisabled");
  return this.amaService.Difference_In_Days > 7 ? false : true;
  }
  btnReportDisable(status) {
  return status == 1 ? false : true;
  }
  filterText(e) {
  if (e) {
  this.amaService.filterData = this.amaService.userAskedQuestions['data'].filter((ele) => {
  if (ele && ele.question && ele.question.length > 0 && ele.question[0].Q)
  {
    let text = ele.question[0].Q.toLowerCase();
    let searchText = e.toLowerCase();
    if (text.includes(searchText)) return ele;
  }
  if (ele.status == 0) {
  if ("submitted".includes(e.toLowerCase())) return ele;}
  else if (ele.status == 1) {
    if ("delivered".includes(e.toLowerCase())) return ele;
  }
  });
  } 
  else {
  this.amaService.filterData = this.amaService.userAskedQuestions['data'];
  }
  }

  viewDetails(id) {
  this.router.navigate([`ama/view-details/${id}`]);
  }

  PopUp = () => {
    this.Dialog.OpenSampleDialoge();
  }

  goToAskCrownitPage(ind:number) {
    if(ind == 0 )
    {
      this.router.navigate(['ama/ask-crownit']);
    }
    else
    {
      if(this.amaService.Difference_In_Days > 7)
      {
        this.router.navigate(['ama/ask-crownit']);
      }
    }
  }
  ViewDetails = (id:any) =>
  {
    this.router.navigateByUrl(`/ama/view-details/${id}`);
  }
  ReportDetails(id:any){
    this.amaService.getQuestionDetails(id).subscribe((result) => {
      // this.filledQue=result;
      console.log('after ReportDetails  : ', result);
      this.router.navigate([`repo/details/${result.data[0].uuid}`]);
      // this.router.navigate([`home/repository-report/details/${result.data[0].uuid}`]);
    }, (err) => {
      console.log('after getQuestionDetails UI Error:: ', err);
    });
  }
  Date = (date:any) =>
  {
    var d = date.slice(0,10);
    var arr = d.split('-');
    var year = +arr[0];
    var month = +arr[1];
    var day = +arr[2];
    var arr1 = ['Jan','Feb','Mar','Apr','May','Jun','July','Aug','Sept','Oct','Nov','Dec'];
    var res =  day + " " + arr1[month-1]+ ' ' + year;
    return res;
  }
  
}
